import { FC, ReactNode } from "react";
import classes from "./Badge.module.scss";

type Props = {
  type?: string;
  children?: ReactNode;
};

const Badge: FC<Props> = ({ type, children }) => {
  return (
    <div className={classes["badge"] + " " + classes[`badge--${type}`]}>
      <span className={classes["badge__name"]}>{children}</span>
    </div>
  );
};

export default Badge;
